import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LanguageService } from 'src/app/services/language/language.service';
import { FromService } from 'src/app/services/form/from.service';
import { FormItem, FormPageItem, Lang } from 'src/app/models/forms';
import { FromModalComponent } from './from-modal/from-modal.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SpinnerComponent } from "../../layout/spinner/spinner.component";

@Component({
  selector: 'app-forms',
  imports: [CommonModule, FormsModule, SpinnerComponent],
  templateUrl: './forms.component.html',
  styleUrl: './forms.component.css'
})
export class FormsComponent {
  lang: Lang = 'geo';

  loadingPages = false;
  loadingForms = false;

  // 1) Pages that are "form pages"
  pages: FormPageItem[] = [];

  // selected form-page menu_page
  selectedMenuPage: number | null = null;

  // 2) Existing forms (filtered by selectedMenuPage)
  forms: FormItem[] = [];


selectedSubmission: any = null;
submissions: any[] = [];
loadingSubmissions = false;
selectedFormId: number | null = null;

  constructor(
    private modal: NgbModal,
    private langService: LanguageService,
    private service: FromService
  ) {}

  ngOnInit(): void {
    this.lang = this.langService.getLanguage() as Lang;

    // language switch
    this.langService.currentLanguage$.subscribe((l: string) => {
      this.lang = l as Lang;
      this.loadPages();
    });

    this.loadPages();
  }

  loadPages() {
    this.loadingPages = true;
    this.pages = [];
    this.forms = [];
    this.selectedMenuPage = null;

    this.service.getFormPages(this.lang).subscribe({
      next: (res: any) => {
        this.pages = res?.data ?? [];

        // default: pick first page (if exists)
        if (this.pages.length) {
          this.selectedMenuPage = this.pages[0].menu_page;
          this.loadForms();
        }
      },
      error: () => {},
      complete: () => (this.loadingPages = false),
    });
  }

  onPageChange(menuPage: number | null) {
    this.selectedMenuPage = menuPage;
    this.loadForms();
  }

  loadForms() {
    if (!this.selectedMenuPage) {
      this.forms = [];
      return;
    }

    this.loadingForms = true;

    this.service.getForms(this.lang, this.selectedMenuPage).subscribe({
      next: (res: any) => {
        this.forms = res?.data ?? [];
      },
      error: () => {},
      complete: () => (this.loadingForms = false),
    });
  }

  // Create by selecting a menu_page (from select)
  openCreate() {
    if (!this.selectedMenuPage) return;

    const ref = this.modal.open(FromModalComponent, { size: 'xl', scrollable: true });
    ref.componentInstance.lang = this.lang;
    ref.componentInstance.menuPage = this.selectedMenuPage;

    ref.result.then(
      () => this.loadForms(),
      () => {}
    );
  }

  openEdit(formId: number) {
    const ref = this.modal.open(FromModalComponent, { size: 'xl', scrollable: true });
    ref.componentInstance.lang = this.lang;
    ref.componentInstance.formId = formId;

    ref.result.then(
      () => this.loadForms(),
      () => {}
    );
  }

  deleteForm(id: number) {
    if (!confirm('ნამდვილად გსურს ფორმის წაშლა?')) {
      return;
    }

    this.service.deleteForm(id, this.lang, true).subscribe({
      next: () => {
        this.loadForms();
      },
      error: (err) => {
        console.error('ფორმის წაშლის შეცდომა', err);
        alert('ფორმის წაშლა ვერ მოხერხდა');
      }
    });
  }

  toggleVisible(id: number) {
    this.service.toggleVisible(id, this.lang).subscribe({
      next: () => {
        this.loadForms();
      },
      error: (err) => {
        console.error('ფორმის ხილვადობის შეცდომა', err);
        alert('ფორმის ჩართვა/გამორთვა ვერ მოხერხდა');
      }
    });
  }


  loadSubmissions(formId: number): void {
    this.selectedFormId = formId;
    this.selectedSubmission = null;
    this.loadingSubmissions = true;

    this.service.getSubmissions(formId, this.lang).subscribe({
      next: (res: any) => {
        // support both {data: [...]} and paginator {data: {data: [...]}}
        this.submissions = res?.data?.data ?? res?.data ?? [];
        this.loadingSubmissions = false;
      },
      error: (err) => {
        console.error('შეტყობინებების ჩატვირთვის შეცდომა', err);
        this.submissions = [];
        this.loadingSubmissions = false;
      }
    });
  }

  openSubmission(submissionId: number): void {
    this.service.getSubmission(submissionId).subscribe({
      next: (res: any) => {
        const rawJson = res?.payload_json || res?.data_json || null;

        if (rawJson && typeof rawJson === 'string') {
          try {
            const parsed = JSON.parse(rawJson);
            res.payload = parsed;
            res.data = parsed;
          } catch {
            res.payload = null;
            res.data = null;
          }
        } else if (rawJson && typeof rawJson === 'object') {
          res.payload = rawJson;
          res.data = rawJson;
        } else {
          res.payload = null;
          res.data = null;
        }

        this.selectedSubmission = res;
      },
      error: (err) => {
        console.error('შეტყობინების წამოღების შეცდომა', err);
        alert('შეტყობინების დეტალების ჩატვირთვა ვერ მოხერხდა');
      }
    });
  }

  closeSubmissionModal(): void {
    this.selectedSubmission = null;
  }

  deleteSubmission(id: number): void {

  if (!confirm('ნამდვილად გსურთ შეტყობინების წაშლა?')) {
    return;
  }

  this.service.deleteSubmission(id).subscribe({
    next: () => {

      // modal დახურვა
      this.selectedSubmission = null;

      // სიის თავიდან ჩატვირთვა
      if (this.selectedFormId) {
        this.loadSubmissions(this.selectedFormId);
      }

    },
    error: (err) => {
      console.error('შეტყობინების წაშლის შეცდომა', err);
      alert('წაშლა ვერ მოხერხდა');
    }
  });

}

}
